import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import notificationSound from '../assets/sounds/notification.mp3'

export default {
  data() {
    return {
      send_message: null,
      connected: false,
      pending: sessionStorage.getItem("notification") ?? 0,
      socket: null,
      stompClient: null,
    };
  },

  methods: {
    setPending() {
      if (this.pending === null || this.pending === 0) {
        this.pending = 1;
      } else {
        this.pending++;
      }
      sessionStorage.setItem("notification", this.pending);
    },
    send(msgTxt) {
      this.send_message = msgTxt;
      if (this.stompClient && this.stompClient.connected) {
        const msg = { name: this.send_message };
        this.stompClient.send("/app/hello", JSON.stringify(msg), {});
      }
    },
    connect() {
      const zetrixAccount = sessionStorage.getItem("zetrixAccount");

      if (!zetrixAccount) {
        console.log("WebSocket: no zetrixAccount in session, skipping connect");
        return;
      }

      this.socket = new SockJS(process.env.VUE_APP_WS_URL);
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.connect(
        { appPrefix: "multisig", subscriberId: zetrixAccount },
        (frame) => {
          this.connected = true;
          this.stompClient.subscribe("/user/queue/notifications", (tick) => {
            var notification = JSON.parse(tick.body);
            // this.setPending();
            var audio = new Audio(notificationSound);
            audio.play();
            setTimeout(() => {
              this.receivedNoti = false;
            }, 5000);
          });
        },
        (error) => {
          console.error(error);
          this.connected = false;
          this.connect();
        }
      );
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    tickleConnection() {
      this.connected ? this.disconnect() : this.connect();
    },
  },
};
